import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../../_constants/validation-format-constants';
import { AddressRawDto } from '../../../_models/address-raw-dto';

export class OwnerLogReturnedMailParametersDto {
    communityId: number;
    customerId: string;

    @Type(() => Date)
    @Transform(dateJSONTransformer, { toPlainOnly: true })
    mailReceivedOn: Date;

    returnedReasonCode: string;
    mailClassCode: string;
    mailTypeCode: string;
    addressMatches: string;
    updateMailingAddress: boolean;
    @Type(() => AddressRawDto)
    mailingAddress: AddressRawDto;
    clearCache = true;
}
